import get from 'lodash/get';
import uniq from 'lodash/uniq';

const getAuthorUid = (message, param) => parseInt(get(message, param), 10);

const getAuthorUids = channel => {
  const messages = get(channel, 'messages', []);
  const uids = messages
    .reduce((acc, message) => {
      const msgAuthorUid = getAuthorUid(message, 'authorUid');
      const msgTeamUser = getAuthorUid(message, 'userId');
      acc.push(msgAuthorUid);
      acc.push(msgTeamUser);

      const { quotedMessage } = message;
      if (quotedMessage) {
        const replyAuthorUid = getAuthorUid(quotedMessage, 'authorUid');
        const replyTeamUid = getAuthorUid(quotedMessage, 'userId');
        acc.push(replyAuthorUid);
        acc.push(replyTeamUid);
      }

      return acc;
    }, [])
    .filter(Boolean);

  return uniq(uids);
};

export default getAuthorUids;



// WEBPACK FOOTER //
// ./src/redux/chatConnection/helpers/getAuthorUids.js